import { useTransitionRouter } from "../transition-router";
import { HttpClient, type HttpClientOptions } from "./http-client";
import type { OpenApiPaths } from "./http-client-openapi.types";

export const useHttpClientFactory = <P extends OpenApiPaths>(apiUrl: string, options: HttpClientOptions) => {
  const router = useTransitionRouter();
  const client = new HttpClient<P>(apiUrl, {
    onRetryFail: (response) => [401, 403].includes(response.status) && router.push("/login"),
    ...options,
  });

  return client;
};
